export const addStockTransaction = async (StockTransactionData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "addStockTransactions", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...StockTransactionData })
    });
    const jsonResponse = await response.json();

    if (jsonResponse?.success === true) {
        let data = StockTransactionData;
        data.id = jsonResponse?.data?.id;
        
        jsonResponse.data = data;
    }
    console.log('Add StockTransaction Response:', jsonResponse);
    return jsonResponse;
};
export const updateStockTransaction = async (StockTransactionId, StockTransactionData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "updateStockTransactions", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: StockTransactionId, ...StockTransactionData })
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = StockTransactionData;
        data.id = StockTransactionId;
        jsonResponse.data = data;
    }
    console.log('Update StockTransaction Response:', response);
    return jsonResponse;
};
export const deleteStockTransaction = async (StockTransactionId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "deleteStockTransactions", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: StockTransactionId })
    });
    return await response.json();
};
